import { FieldErrors } from 'react-hook-form/dist/types/errors';

import { FormProps } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/UpdateRiskRegisterModal/components/UpdateRiskRegisterForm/UpdateRiskRegisterForm';

export const requiredWhenSelected = (
    selectedOption: FormProps['linkOption'], // option selected by the user
    controllerOption: FormProps['linkOption'], // the option of the controller option
    errorMessage: string,
) => ({
    validate: (value: unknown) => {
        if (selectedOption !== controllerOption) return true; // not selected → no validation
        if (Array.isArray(value)) return value.length > 0 || errorMessage;
        return Boolean(value) || errorMessage;
    },
});

export const getFormError = (userSelectedOption: FormProps['linkOption'], formErrors: FieldErrors<FormProps>) => {
    return userSelectedOption && userSelectedOption !== 'all'
        ? formErrors.activitiesByKey?.[userSelectedOption as keyof FormProps['activitiesByKey']]
        : undefined;
};
